// extracted by mini-css-extract-plugin
export default {"scoreboard":"Scoreboard_scoreboard__gJ2KI","header":"Scoreboard_header__VEjfG","result":"Scoreboard_result__soBg6"};